module.exports = __webpack_public_path__ + "img/cent270.1a26245c.jpg";